var _path, _path2, _path3, _path4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChatWithUsList1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 30,
    viewBox: "0 0 31 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.8735 13.4875V18.4875C22.8735 18.8125 22.8609 19.125 22.8234 19.425C22.5359 22.8 20.5484 24.475 16.8859 24.475H16.3859C16.0734 24.475 15.7734 24.625 15.5859 24.875L14.086 26.875C13.4235 27.7625 12.3484 27.7625 11.6859 26.875L10.1859 24.875C10.0234 24.6625 9.66094 24.475 9.38594 24.475H8.88595C4.89845 24.475 2.89844 23.4875 2.89844 18.4875V13.4875C2.89844 9.82501 4.58595 7.83751 7.94845 7.55001C8.24845 7.51251 8.56095 7.5 8.88595 7.5H16.8859C20.8734 7.5 22.8735 9.50001 22.8735 13.4875Z",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M27.8703 8.48751V13.4875C27.8703 17.1625 26.1828 19.1375 22.8203 19.425C22.8578 19.125 22.8703 18.8125 22.8703 18.4875V13.4875C22.8703 9.50001 20.8703 7.5 16.8828 7.5H8.88281C8.55781 7.5 8.24531 7.51251 7.94531 7.55001C8.23281 4.18751 10.2203 2.5 13.8828 2.5H21.8828C25.8703 2.5 27.8703 4.50001 27.8703 8.48751Z",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2678 16.5625H17.2791",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.8928 16.5625H12.9041",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.51781 16.5625H8.52906",
    stroke: "#219EBC",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChatWithUsList1);
export default __webpack_public_path__ + "static/media/chatWithUsList1.17a40a95051e637dabb2e54a0b55bc73.svg";
export { ForwardRef as ReactComponent };